module.exports = __webpack_public_path__ + "img/7clubs.acc2e108.jpg";